import { render, staticRenderFns } from "./userDetailsList.vue?vue&type=template&id=6a946e98"
import script from "./userDetailsList.vue.ts?vue&type=script&lang=ts&external"
export * from "./userDetailsList.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports